import { Routes } from '@angular/router';
import { CcdlErrorPageComponent } from '@cpm-pr1618001/ng-design-lib';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { authGuardFn } from './auth.guard';
import { DashboardContainerComponent } from './dashboard/dashboard.container.component';
import { expensesGuard } from './dashboard/expenses/guards/expenses.guard';
import { ExpensesEffects } from './dashboard/expenses/store/effects/expenses.effects';
import { expensesFeature } from './dashboard/expenses/store/feature/expenses.feature';
import { StocksEffects } from './dashboard/stocks/store/effects/stocks.effects';
import { stocksFeature } from './dashboard/stocks/store/feature/stocks.feature';
import { SettingsEffects } from './settings/store/effects/settings.effects';
import { settingsFeature } from './settings/store/feature/settings.feature';
import { SupportEffects } from './support/store/effects/support.effects';
import { supportFeature } from './support/store/feature/support.feature';

export const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardContainerComponent,
    canActivate: [authGuardFn],
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./dashboard/home/home.container.component').then(
            (m) => m.HomeContainerComponent,
          ),
      },
      {
        path: 'savings',
        loadComponent: () =>
          import('./dashboard/savings/savings.container.component').then(
            (m) => m.SavingsContainerComponent,
          ),
      },
      {
        path: 'stocks',
        loadComponent: () =>
          import('./dashboard/stocks/stocks.container.component').then(
            (m) => m.StocksContainerComponent,
          ),
        providers: [
          provideState(stocksFeature),
          provideEffects([StocksEffects]),
        ],
      },
      {
        path: 'credit-cards',
        loadComponent: () =>
          import('./dashboard/credit-cards/credit-cards.container.component').then(
            (m) => m.CreditCardsContainerComponent,
          ),
      },
      {
        path: 'loans',
        loadComponent: () =>
          import('./dashboard/loans/loans.container.component').then(
            (m) => m.LoansContainerComponent,
          ),
      },
      {
        path: 'expenses',
        loadComponent: () =>
          import('./dashboard/expenses/expenses.container.component').then(
            (m) => m.ExpensesContainerComponent,
          ),
        providers: [
          provideState(expensesFeature),
          provideEffects([ExpensesEffects]),
        ],
        canActivate: [expensesGuard],
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
    ],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/SETTINGS_ROUTES').then((r) => r.SETTINGS_ROUTES),
    canActivate: [authGuardFn],
    providers: [
      provideState(settingsFeature),
      provideEffects([SettingsEffects]),
    ],
  },
  {
    path: 'support',
    loadChildren: () =>
      import('./support/SUPPORT_ROUTES').then((r) => r.SUPPORT_ROUTES),
    providers: [provideState(supportFeature), provideEffects([SupportEffects])],
    canActivate: [authGuardFn],
  },
  {
    path: 'error-page',
    component: CcdlErrorPageComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
];
